import {
  REQUEST_DATA_SUCCESS,
  REQUEST_INTERESSE_SUCCESS
} from './mutation-types'
import moment from 'moment'

export default {
  [REQUEST_DATA_SUCCESS](state, payload) {
    state.items = payload.Result.map(i => {
      i.fData = moment(i.Data).format('L')
      return i
    })
    state.pagination = {
      page: payload.Page,
      pageCount: payload.PageCount,
      pageSize: payload.PageSize
    }
  },
  [REQUEST_INTERESSE_SUCCESS](state, payload) {
    if (payload) {
      state.interesse = payload
    }
  }
}
